<template>
    <div class="rightpanel" style="position: relative">
        <!-- <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-d-arrow-right">
        <transition-group name="breadcrumb">
          <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.name">
            <span v-if="index===0&&levelList.length>1" style="float:left;cursor: pointer;font-size:16px;margin-right: 10px;" @click="back(levelList[levelList.length-2])"><i class="el-icon-back" /></span>
            <span :key="index" class="no-redirect">{{ item.name }}</span>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb> -->
      <div v-if="showPicture">
      <el-button-group v-if="(type === 0 || (wjzxDeptMgr && type === 1) || (wjzxCompanyMgr && type === 2)) && Number(treeNode.id) !== 1">
        <el-button v-if="!isHide" type="primary" @click="upload">
                        <span style="position: relative; top: -3px">
                            <svg aria-hidden="true" class="svg_stile">
                                <use :xlink:href="'#icon-wjzx_uploadFlie'" />
                            </svg>
                            上传
                        </span>
                    </el-button>
                    <el-button v-if="searchType === '0'&&!isHide" :id="styleBagrand" @click="addFolder"><span style="position: relative; top: -1px">新建文件夹</span></el-button>
                    <el-button plain icon="el-icon-menu" @click="tableShow = true;" />
                    <el-button plain @click="tableShow = false;"><svg-icon icon-class="list" /></el-button>
      </el-button-group>
      <el-button-group v-else>
                    <el-button plain icon="el-icon-menu" @click="tableShow = true;" />
                    <el-button plain @click="tableShow = false;"><svg-icon icon-class="list" /></el-button>
      </el-button-group>
        <div v-show="tableShow">
        <Cover ref="cover" :type="typePhoto" :cate="cate" :search-key="searchtext" :is-check-all="checkAll" :is-check-style="isIndeterminate" ::prefix-full-name="prefixFullName" :urlsearch="urlsearch" />
      </div>
      <data-table v-show="!tableShow" ref="dataTable" class="dataTable" :module-info="moduleInfo" :tb-columns="tableList" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-cell-click="cellclick" :on-selected-rows-change="selectedRowsChange">
        </data-table>
        </div>
        <data-table v-else v-show="tableShow" ref="dataTable" class="dataTable" :module-info="moduleInfo" :tb-columns="tableList" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-cell-click="cellclick" :on-selected-rows-change="selectedRowsChange">
            <template v-if="(type === 0 || (wjzxDeptMgr && type === 1) || (wjzxCompanyMgr && type === 2)) && Number(treeNode.id) !== 1" slot="toolbarLeft-slotLeft">
                <div class="buttonTitle">
                    <el-button v-if="!isHide" type="primary" @click="upload">
                        <span style="position: relative; top: -3px">
                            <svg aria-hidden="true" class="svg_stile">
                                <use :xlink:href="'#icon-wjzx_uploadFlie'" />
                            </svg>
                            上传
                        </span>
                    </el-button>
                    <el-button v-if="searchType === '0'&&!isHide" :id="styleBagrand" @click="addFolder"><span style="position: relative; top: -1px">新建文件夹</span></el-button>
                </div>
            </template>
        </data-table>
        <Basicform :title="moduleInfoShare.title" :win-width="moduleInfoShare.winWidth" :win-height="moduleInfoShare.winHeight" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit">
            <template #default="slotProps">
                <FileForm :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfoShare" />
            </template>
        </Basicform>
        <!-- 添加文件夹弹框 -->
        <el-dialog v-if="dialogFormVisible" v-el-drag-dialog title="新建文件夹" :visible.sync="dialogFormVisible" width="620px" :close-on-click-modal="false">
            <el-form :rules="rules" :model="form" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        所属分类
                                    </td>
                                    <td class="el-table__cell tdcont tdw83">
                                        <el-cascader ref="cascaderServer" v-model="folderVo.fullName1" style="width: 100%" :options="treeData1" :show-all-levels="false" :props="{ checkStrictly: true }" @change="selectFolderId"></el-cascader>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required" style="color: red">*</span>
                                        文件夹名称
                                    </td>
                                    <td class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="文件夹名称" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input ref="emailReceiveServer" v-model="folderVo.folderName" maxlength="400" type="text" autocomplete="false" placeholder="请输入文件夹名称,长度不超过200字符" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                               <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        授权方式
                                    </td>
                                    <td colspan="3" class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="指定类型" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-radio-group v-model="folderVo.permissionType">
                                                    <el-radio :label="1">全部</el-radio>
                                                    <el-radio :label="2">指定部门</el-radio>
                                                    <el-radio :label="3">指定群组</el-radio>
                                                    <el-radio :label="4">指定人员</el-radio>
                                                </el-radio-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr v-if="folderVo.permissionType !== 1">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-if="folderVo.permissionType === 3">指定群组</span>
                                        <span v-if="folderVo.permissionType === 2">指定部门</span>
                                        <span v-if="folderVo.permissionType === 4">指定人员</span>
                                    </td>
                                    <td colspan="3" class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="群组" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="folderVo.permissionType === 3" v-model="permissionName" v-select-dialog="'workgroup'" placeholder="请选择群组" readonly="readonly" multiple="true" type="textarea" :root-org-code="loginUser.orgCode" name="newDeptIds" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="部门" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="folderVo.permissionType === 2" v-model="permissionName" v-select-dialog="'suborg'" placeholder="请选择部门" org-level="2" readonly="readonly" multiple="true" type="textarea" :root-org-code="loginUser.orgCode" name="newDeptIds" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="folderVo.permissionType === 4" v-model="permissionName" v-select-dialog="'staff'" placeholder="请选择人员" readonly="readonly" multiple="true" type="textarea" name="newDeptIds" :root-org-code="loginUser.orgCode" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :icon="'el-icon-close'" @click="dialogFormVisible = false">关 闭</el-button>
                <el-button type="primary" :icon="'el-icon-check'" @click="groupingConfirm">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 上传文件弹框 -->
        <el-dialog v-if="dialogFormVisibleFolder" v-el-drag-dialog title="上传文件" :visible.sync="dialogFormVisibleFolder" width="620px" :close-on-click-modal="false">
            <el-form :rules="rules" :model="form" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        所属分类
                                    </td>
                                    <td class="el-table__cell tdcont tdw83">
                                        <el-cascader ref="cascader" v-model="uploadVo.fullName1" style="width: 100%" :options="treeData1" :props="{ checkStrictly: true }" :show-all-levels="false" @change="selectUploadId"></el-cascader>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required" style="color: red">*</span>
                                        上传文件
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" style="width: 100%">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="上传文件" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-upload ref="upload" style="width: 100%" :on-change="handleUploadChange" action="" :file-list="uploadVo.attach" :show-file-list="false" :auto-upload="false" :with-credentials="true" :multiple="true" :accept="'*'">
                                                    <el-input v-model="uploadVo.attachFileName" readonly style="width: 100%" name="salaryAttachName" placeholder="请选择文件">
                                                        <el-button slot="append" icon="el-icon-upload2" />
                                                    </el-input>
                                                </el-upload>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :icon="'el-icon-close'" @click="dialogFormVisibleFolder = false">关 闭</el-button>
                <el-button type="primary" :icon="'el-icon-check'" :loading="updateLoading" @click="groupingConfirmFolder">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 添加文件夹弹框 -->
        <el-dialog v-if="dialogFormVisibleFile" v-el-drag-dialog title="文件夹设置" :visible.sync="dialogFormVisibleFile" width="620px" :close-on-click-modal="false">
            <el-form :rules="rules" :model="fileVo" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required" style="color: red">*</span>
                                        名称
                                    </td>
                                    <td class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="文件名称" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input ref="emailReceiveServer" v-model="fileVo.name" type="text" autocomplete="false" placeholder="请输入文件名称" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        授权方式
                                    </td>
                                    <td colspan="3" class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="指定类型" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-radio-group v-model="fileVo.permissionType">
                                                    <el-radio :label="1">全部</el-radio>
                                                    <el-radio :label="2">指定部门</el-radio>
                                                    <el-radio :label="3">指定群组</el-radio>
                                                    <el-radio :label="4">指定人员</el-radio>
                                                </el-radio-group>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr v-if="fileVo.permissionType !== 1 || !fileVo.permissionType">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-if="fileVo.permissionType === 3">指定群组</span>
                                        <span v-if="fileVo.permissionType === 2">指定部门</span>
                                        <span v-if="fileVo.permissionType === 4">指定人员</span>
                                    </td>
                                    <td colspan="3" class="el-table__cell tdcont tdw83">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="群组" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="fileVo.permissionType === 3" v-model="filePermissionName" v-select-dialog="'workgroup'" placeholder="请选择群组" readonly="readonly" multiple="true" type="textarea" :root-org-code="loginUser.orgCode" name="deptIds2" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="部门" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="fileVo.permissionType === 2" v-model="filePermissionName" v-select-dialog="'suborg'" placeholder="请选择部门" org-level="2" readonly="readonly" multiple="true" type="textarea" :root-org-code="loginUser.orgCode" name="deptIds" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-show="fileVo.permissionType === 4" v-model="filePermissionName" v-select-dialog="'staff'" placeholder="请选择人员" readonly="readonly" multiple="true" type="textarea" name="deptIds" :root-org-code="loginUser.orgCode" />
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :icon="'el-icon-close'" @click="dialogFormVisibleFile = false">取 消</el-button>
                <el-button type="primary" :icon="'el-icon-check'" @click="fileConfirm">确 定</el-button>
            </span>
        </el-dialog>
        <ShareRecord />

        <el-dialog v-if="updateLoading" v-el-drag-dialog :visible.sync="updateLoading" :append-to-body="true" :close-on-click-modal="false" width="600px" :title="$tx('pageBtns.uploadFile', '上传文件')">
            {{ uploadVo.uploadingFile }}
            <el-progress :text-inside="true" :stroke-width="20" :percentage="uploadVo.progress" status="success" />
        </el-dialog>
    </div>
</template>

<script>
import $ from 'jquery'
const moment = require('moment')
import { mapGetters } from 'vuex'
// 分享表单
import FileForm from './FileForm'
// 分享记录
import ShareRecord from './ShareRecord'
import Cover from './Cover.vue'
export default {
    components: {
        FileForm,
        ShareRecord,
        Cover
    },
    props: {
        searchType: {
            type: String,
            default: function () {
                return '0'
            }
        },
        treeNode: {
            type: Object,
            default: function () {
                return {}
            }
        },
        language: {
            type: Array,
            default: function () {
                return []
            }
        },
        gdflszVos: {
            type: Array,
            default: function () {
                return []
            }
        },
        mapList: {
            type: Array,
            default: function () {
                return []
            }
        },
        flieType: {
            type: String,
            default: function () {
                return 0
            }
        },
        type: {
            type: Number,
            default: function () {
                return 0
            }
        },
        root: {
            type: Array,
            default: function () {
                return []
            }
        },
        prefixFullName: {
            type: String,
            default: function () {
                return ''
            }
        },
        showPicture: {
            type: Boolean,
            default: function () {
                return false
            }
        }
    },
    data() {
        return {
            urlsearch: '',
            typePhoto: 'photo',
            permissionName: '',
            filePermissionName: '',
            vo: {
                categoryName: '',
                groupName: '',
                categoryId: null
            },
            title: '归档文件',
            loginUser: this.$store.getters.loginUser,
            tableShow: false,
            moduleInfo: {
                getByIdUrl: '/disk/file/getById',
                listDataUrl: '',
                addNewUrl: '/disk/file/addNew',
                insertUrl: '/disk/file/insert',
                updateUrl: '/disk/file/update',
                uploadUrl: '/disk/file/upload',
                downloadUrl: '/disk/file/downloadById',
                delUrl: '/disk/file/delete',
                winWidth: 1000, // 查看、编辑窗口宽度
                winHeight: 650 // 查看、编辑窗口高度
            },
            tableList: [
                {
                    field: 'state',
                    checkbox: true,
                    width: '45px'
                },
                {
                    field: 'index',
                    title: '序号',
                    width: '45px',
                    align: 'center',
                    valign: 'middle'
                },
                {
                    propFormatter: 'component：@/wapp/wjzx/components/WjzxComponentTbColumns?aaa',
                    field: 'name',
                    title: '文件名称',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 0
                },
                {
                    field: 'actualSize',
                    title: '文件大小',
                    width: '110px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: true,
                    searchable: false,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 3,
                    elementFormatter: '',
                    propFormatter: 'function：operateActualSize'
                },
                {
                    field: 'createName',
                    title: '创建人',
                    width: '100px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: false,
                    searchable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 3,
                    elementFormatter: ''
                },
                {
                    field: 'createDate',
                    title: '创建时间',
                    width: '130px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: true,
                    listAdvSearchElement: 'date',
                    elementFormatter: 'format：yyyy-MM-dd HH:mm\r\n',
                    listAdvSearchIndex: 4
                }
            ],
            // 列表页面操作按钮定义
            listpageBtns: [
                {
                    btnName: '下载',
                    btnIcon: 'wjzx_downcopy.svg',
                    btnClick: this.allDownload,
                    btnPermission: '',
                    id: 'btn_download',
                    btnType: 'toolbar'
                },
                {
                    btnName: '收藏',
                    btnIcon: 'wjzx_shoucang.svg',
                    btnClick: this.collection,
                    btnPermission: '',
                    id: '',
                    btnType: 'toolbar'
                },
                {
                    btnName: '分享',
                    btnIcon: 'wjzx_fenxaing.svg',
                    btnClick: this.allShare,
                    btnPermission: '',
                    id: '',
                    btnType: 'toolbar'
                },
                {
                    btnName: '转发邮件',
                    btnIcon: 'wjzx_forwarding.svg',
                    btnClick: this.writeMail,
                    btnPermission: '',
                    id: '',
                    btnType: 'toolbar'
                },
                {
                    id: 'btn_download',
                    btnName: '下载',
                    btnIcon: 'wjzx_down.svg',
                    btnClick: this.download,
                    btnPermission: 'setting',
                    btnType: 'column'
                }
            ],
            canEdit: 1,
            rowsSelected: [], // 批量选择
            num: '',
            fileList: [], // 附件
            dialogFormVisible: false, // 新建文件夹弹框
            dialogFormVisibleFolder: false, // 上传文件弹框
            fileMoudlueInfo: {
                getByIdUrl: '/disk/folder/getById',
                listDataUrl: '/disk/folder/listdata',
                addNewUrl: '/disk/folder/addNew',
                insertUrl: '/disk/folder/insert',
                updateUrl: '/disk/folder/update',
                uploadUrl: '/disk/folder/upload',
                delUrl: '/disk/folder/delete',
                winWidth: 1000, // 查看、编辑窗口宽度
                winHeight: 650 // 查看、编辑窗口高度
            },
            addOrupdateContacts: false, // 判断文件夹是新增还是修改 true/新增 false/修改
            folderVo: {}, // 文件夹对象
            usersetId: this.$store.getters.loginUser,
            treeData1: [],
            addOrupdateContactsFolder: false, // 判断上传文件是新增还是修改 true/新增 false/修改
            uploadVo: {
                fileDiffer: this.type,
                fullName: '',
                folderId: '',
                attach: [],
                attachFileName: ''
            },
            dialogFormVisibleFile: false, // 编辑文件名称
            fileVo: {}, // 重命名文件
            moduleInfoShare: {
                title: '分享',
                getByIdUrl: '/disk/share/getById',
                listDataUrl: '/disk/share/listdata',
                addNewUrl: '/disk/share/addNew',
                insertUrl: '/disk/share/insert',
                updateUrl: '/disk/share/update',
                uploadUrl: '/disk/share/upload',
                delUrl: '/disk/share/delete',
                winWidth: 1000, // 查看、编辑窗口宽度
                winHeight: 650 // 查看、编辑窗口高度
            },
            shareType: 'all', // all批量分享 one操作列分享
            shareObj: {}, // 操作列分享的对象
            isUpload: true, // 区分上传文件和新建文件夹 选择分类 true上传文件
            updateLoading: false, // 上传文件加载状态
            wjzxDeptMgr: false, // 部门文件管理员
            wjzxCompanyMgr: false, // 单位文件管理员
            levelList: [], // 文件夹路径数组
            styleBagrand: '',
            getBorder: false,
            accountId: '',
            isHide: false
        }
    },
    computed: {
        ...mapGetters(['routes', 'sidebar'])
    },
    watch: {
        treeNode() {
            this.setListDataUrl()
        },
        flieType() {
            this.setListDataUrl()
        },
        dialogFormVisibleFolder(val) {
            if (!val) {
                this.uploadVo = {
                    fileDiffer: this.type,
                    fullName: '',
                    folderId: '',
                    attach: [],
                    attachFileName: ''
                }
            }
        }
    },
    created() {
        // this.tableList.push({
        //     field: 'column_operate',
        //     title: '操作',
        //     width: '120px',
        //     align: 'center',
        //     valign: 'middle'
        // })
        let roles = this.$store.getters.roles
        if (!roles.includes('dataAdmin')) {
            this.isHide = true
        }
        this.tableList.push({ propFormatter: 'function：operateFormatter', listAdvSearchElement: '', field: 'state', width: '150px', sortable: false, propType: 'String', align: 'center', title: '操作', searchable: false })
        this.permissionsControl()
        this.setListDataUrl()
        this.$bus.$on('selectTree', this.queryData)
        // 刷新列表
        this.$bus.$on('setListDataUrl', this.setListDataUrl)
        this.queryData()
        this.styleBagrand = this.Cookies.get('uiStyle')
    },
    beforeDestroy() {
        this.$bus.$off('selectTree', this.queryData)
        // 刷新列表
        this.$bus.$off('setListDataUrl', this.setListDataUrl)
    },
    mounted() {},
    methods: {
        // 选择部门、科室、班组
        onSelectSuborgCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += ','
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            if (attr.name === 'newDeptIds') {
                this.folderVo.passenger.filePermission = {}
                this.permissionName = selected
                this.$set(this.folderVo.passenger.filePermission, 'permissionId', selectCode)
                this.$set(this.folderVo.passenger.filePermission, 'permissionName', selected)
            } else {
                this.$set(this.fileVo.passenger.filePermission, 'permissionId', selectCode)
                this.$set(this.fileVo.passenger.filePermission, 'permissionName', selected)
                this.filePermissionName = selected
            }
        },
        // 选择工作群组
        onSelectWorkgroupCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += ','
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            if (attr.name === 'newDeptIds') {
                this.folderVo.passenger.filePermission = {}
                this.permissionName = selected
                this.$set(this.folderVo.passenger.filePermission, 'permissionId', selectCode)
                this.$set(this.folderVo.passenger.filePermission, 'permissionName', selected)
            } else {
                this.$set(this.fileVo.passenger.filePermission, 'permissionId', selectCode)
                this.$set(this.fileVo.passenger.filePermission, 'permissionName', selected)
                this.filePermissionName = selected
            }
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selectCode += ','
                if (selected !== '') selected += '、'
                selected += node.name
                selectCode += node.personId
            })

            if (attr.name === 'newDeptIds') {
                this.folderVo.passenger.filePermission = {}
                this.permissionName = selected
                this.$set(this.folderVo.passenger.filePermission, 'permissionId', selectCode)
                this.$set(this.folderVo.passenger.filePermission, 'permissionName', selected)
            } else {
                this.$set(this.fileVo.passenger.filePermission, 'permissionId', selectCode)
                this.$set(this.fileVo.passenger.filePermission, 'permissionName', selected)
                this.filePermissionName = selected
            }
        },
        // render函数动态渲染图标
        operateFormatter(h, row, column, cellValue, index) {
            // fiveStar 未收藏  已收藏  fiveStar3
            var list = h('span', [
                h(
                    'a',
                    {
                        attrs: {
                            title: '收藏'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.cancel(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'fiveStar'
                                    }
                                })
                            ]
                        )
                    ]
                ),
                h(
                    'a',
                    {
                        attrs: {
                            title: '分享记录'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.shareRecord(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_sharejl'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '下载'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.download(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_down'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '编辑'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.editObjectFile(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_edit'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '删除'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.deleteIds(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_del'
                                    }
                                })
                            ]
                        )
                    ]
                )
            ])

            var list2 = h('span', [
                h(
                    'a',
                    {
                        attrs: {
                            title: '取消收藏'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.qxCancel(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'fiveStar3'
                                    }
                                })
                            ]
                        )
                    ]
                ),
                h(
                    'a',
                    {
                        attrs: {
                            title: '分享记录'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.shareRecord(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_sharejl'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '下载'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.download(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_down'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '编辑'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.editObjectFile(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_edit'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '删除'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.$nextTick(() => {
                                    _this.deleteIds(row)
                                })
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_del'
                                    }
                                })
                            ]
                        )
                    ]
                )
            ])

            var list3 = h('span', [
                h(
                    'a',
                    {
                        attrs: {
                            title: '收藏'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.cancel(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'fiveStar'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '下载'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.download(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_down'
                                    }
                                })
                            ]
                        )
                    ]
                )
            ])

            var list4 = h('span', [
                h(
                    'a',
                    {
                        attrs: {
                            title: '取消收藏'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.qxCancel(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'fiveStar3'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '下载'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.download(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_down'
                                    }
                                })
                            ]
                        )
                    ]
                )
            ])
            var list5 = h('span', [
                h(
                    'a',
                    {
                        attrs: {
                            title: '收藏'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.cancel(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'fiveStar'
                                    }
                                })
                            ]
                        )
                    ]
                ),
                h(
                    'a',
                    {
                        attrs: {
                            title: '分享记录'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.shareRecord(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_sharejl'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '下载'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.download(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_down'
                                    }
                                })
                            ]
                        )
                    ]
                )

            ])
            var list6 = h('span', [
                h(
                    'a',
                    {
                        attrs: {
                            title: '取消收藏'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.qxCancel(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'fiveStar3'
                                    }
                                })
                            ]
                        )
                    ]
                ),
                h(
                    'a',
                    {
                        attrs: {
                            title: '分享记录'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.shareRecord(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_sharejl'
                                    }
                                })
                            ]
                        )
                    ]
                ),

                h(
                    'a',
                    {
                        attrs: {
                            title: '下载'
                        },
                        class: 'el-link el-link--default is-underline',
                        on: {
                            click: function () {
                                _this.download(row)
                            }
                        }
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'el-link--inner'
                            },
                            [
                                h('svg-icon', {
                                    attrs: {
                                        'icon-class': 'wjzx_down'
                                    }
                                })
                            ]
                        )
                    ]
                )
            ])
            // list 未收藏 list2 已收藏 list3 没有权限未收藏  list4 没有权限已收藏
            var _this = this
            // if (_this.isHide) {
            //     return list5
            // }
            if (this.type === 0) {
                if (Number(row.passenger.isCollect) === 0) {
                    return list
                }
                return list2
            }
            this.$store.state.user.roles.forEach((res) => {
                if (res === 'wjzxDeptMgr') {
                    // 部门文件管理员
                    this.wjzxDeptMgr = true
                } else if (res === 'wjzxCompanyMgr') {
                    // 单位文件管理员
                    this.wjzxCompanyMgr = true
                }
            })
            if ((this.wjzxDeptMgr && this.type === 1) || (this.wjzxCompanyMgr && this.type === 2)) {
                if (this.isHide) {
                    if (Number(row.passenger.isCollect) === 0) {
                        return list5
                    }
                    return list6
                } else {
                    if (Number(row.passenger.isCollect) === 0) {
                        return list
                    }
                    return list2
                }
            } else {
                this.width = '100px'
                if (Number(row.passenger.isCollect) === 0) {
                    return list3
                }
                return list4
            }
        },
        // 权限控制
        permissionsControl() {
            var list = [
                {
                    btnName: '下载',
                    btnIcon: 'wjzx_downcopy.svg',
                    btnClick: this.allDownload,
                    btnPermission: '',
                    id: 'btn_download',
                    btnType: 'toolbar'
                },
                {
                    btnName: '删除',
                    btnIcon: 'wjzx_delcopy.svg',
                    btnClick: this.allDeleteIds,
                    btnPermission: '',
                    id: 'btn_deleteIds',
                    btnType: 'toolbar'
                },
                {
                    btnName: '收藏',
                    btnIcon: 'wjzx_shoucang.svg',
                    btnClick: this.collection,
                    btnPermission: '',
                    id: '',
                    btnType: 'toolbar'
                },
                {
                    id: '',
                    btnName: '移动',
                    btnIcon: 'wjzx_mobile.svg',
                    btnClick: this.mobile,
                    btnPermission: '',
                    btnType: 'toolbar'
                },
                {
                    btnName: '分享',
                    btnIcon: 'wjzx_fenxaing.svg',
                    btnClick: this.allShare,
                    btnPermission: '',
                    id: '',
                    btnType: 'toolbar'
                },
                {
                    btnName: '转发邮件',
                    btnIcon: 'wjzx_forwarding.svg',
                    btnClick: this.writeMail,
                    btnPermission: '',
                    id: '',
                    btnType: 'toolbar'
                },
                {
                    id: 'btn_edit',
                    btnName: '分享记录',
                    btnIcon: 'wjzx_sharejl.svg',
                    btnClick: this.shareRecord,
                    btnPermission: 'editObject',
                    btnType: 'column'
                },
                {
                    id: 'btn_download',
                    btnName: '下载',
                    btnIcon: 'wjzx_down.svg',
                    btnClick: this.download,
                    btnPermission: 'setting',
                    btnType: 'column'
                },
                {
                    id: 'btn_edit',
                    btnName: '编辑',
                    btnIcon: 'wjzx_edit.svg',
                    btnClick: this.editObjectFile,
                    btnPermission: 'editObject',
                    btnType: 'column'
                },
                {
                    id: 'btn_deleteId',
                    btnName: '删除',
                    btnIcon: 'wjzx_del.svg',
                    btnClick: 'deleteIds(row.id);',
                    btnPermission: 'deleteIds',
                    btnType: 'column'
                }
            ]
            if (this.type === 0) {
                this.listpageBtns = list
                return
            }
            this.$store.state.user.roles.forEach((res) => {
                if (res === 'wjzxDeptMgr') {
                    // 部门文件管理员
                    this.wjzxDeptMgr = true
                } else if (res === 'wjzxCompanyMgr') {
                    // 单位文件管理员
                    this.wjzxCompanyMgr = true
                }
            })
            if ((this.wjzxDeptMgr && this.type === 1) || (this.wjzxCompanyMgr && this.type === 2)) {
                this.listpageBtns = list
            } else {
                // 没有权限 操作列变窄
                this.tableList[this.tableList.length - 1].width = '100px'
            }
            if (this.isHide) {
                this.listpageBtns = [
                    {
                        btnName: '下载',
                        btnIcon: 'wjzx_downcopy.svg',
                        btnClick: this.allDownload,
                        btnPermission: '',
                        id: 'btn_download',
                        btnType: 'toolbar'
                    },
                    {
                        btnName: '收藏',
                        btnIcon: 'wjzx_shoucang.svg',
                        btnClick: this.collection,
                        btnPermission: '',
                        id: '',
                        btnType: 'toolbar'
                    },
                    {
                        btnName: '分享',
                        btnIcon: 'wjzx_fenxaing.svg',
                        btnClick: this.allShare,
                        btnPermission: '',
                        id: '',
                        btnType: 'toolbar'
                    },
                    {
                        btnName: '转发邮件',
                        btnIcon: 'wjzx_forwarding.svg',
                        btnClick: this.writeMail,
                        btnPermission: '',
                        id: '',
                        btnType: 'toolbar'
                    },
                    {
                        id: 'btn_edit',
                        btnName: '分享记录',
                        btnIcon: 'wjzx_sharejl.svg',
                        btnClick: this.shareRecord,
                        btnPermission: 'editObject',
                        btnType: 'column'
                    },
                    {
                        id: 'btn_download',
                        btnName: '下载',
                        btnIcon: 'wjzx_down.svg',
                        btnClick: this.download,
                        btnPermission: 'setting',
                        btnType: 'column'
                    }
                ]
            }
        },
        // 选择文件夹回调
        onGdtypeCompleted(selectedNodes, attr) {
            if (!this.isUpload) {
                // 新建文件夹 选择回调
                this.$set(this.folderVo, 'fullName', selectedNodes[0].folderName)
                this.$set(this.folderVo, 'parentId', selectedNodes[0].id === '0' ? null : selectedNodes[0].id)
            } else {
                // 上传文件 选择回调
                this.$set(this.uploadVo, 'fullName', selectedNodes[0].folderName)
                this.$set(this.uploadVo, 'folderId', selectedNodes[0].id === '0' ? null : selectedNodes[0].id)
            }
        },
        // 文件夹选择分类回调
        selectFolderId(value) {
            this.folderVo.parentId = value[value.length - 1] !== '0' ? value[value.length - 1] : null

            this.treeDataList.forEach((item) => {
                if (item.id === this.folderVo.parentId) {
                    this.folderVo.fullName = item.folderName
                }
            })
            if (this.folderVo.folderId === '1') {
                this.folderVo.folderId = null
            }
        },
        // 上传文件选择分类回调
        selectUploadId(value) {
            this.uploadVo.folderId = value[value.length - 1]
            this.uploadVo.busiDataId = value[value.length - 1]

            this.treeDataList.forEach((item) => {
                if (item.id === this.uploadVo.folderId) {
                    this.uploadVo.fullName = item.folderName
                    this.uploadVo.deptId = item.deptId
                    this.uploadVo.deptName = item.deptName
                }
            })
            if (this.uploadVo.folderId === '1') {
                this.uploadVo.folderId = ''
                this.uploadVo.busiDataId = ''
            }
        },
        queryData() {
            // 加载类型节点数据
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: [{ compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                params: {
                    type: this.type,
                    prefixFullName: this.prefixFullName
                },
                url: '/disk/folder/classificationQueryCollection'
            }).then((res) => {
                if (res.code === 'success') {
                    res.body.diskFolders.forEach((node) => {
                        if (!node.parentId) {
                            node.parentId = '1'
                        }
                    })
                    this.root.zjfile[0].id = '1'
                    this.root.zjfile[0].pId = '0'
                    this.root.zjfile[0].value = '1'
                    this.root.zjfile[0].parentId = '0'
                    this.treeData1 = this.treeDataAdapter(this.root.zjfile.concat(res.body.diskFolders))
                    this.treeDataList = this.root.zjfile.concat(res.body.diskFolders)
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        treeDataAdapter(treeData) {
            treeData.forEach((node) => {
                if (!node.parentId) {
                    node.pId = '0'
                } else {
                    node.pId = node.parentId
                }
                node.title = node.name = node.folderName
                node.label = node.folderName
                node.value = node.id
            })
            const tree = this.buildTree(treeData, '0')
            return tree
        },

        buildTree(data, parentId) {
            const tree = []
            data.forEach((node) => {
                if (node.pId === parentId) {
                    const children = this.buildTree(data, node.value)
                    if (children.length > 0) {
                        node.children = children
                    }
                    tree.push(node)
                }
            })
            return tree
        },
        // 选择上传文件成功回调
        handleUploadChange(file, fileList) {
            let name = ''
            fileList.forEach((res) => {
                if (name) {
                    name += ',' + res.name
                } else {
                    name += res.name
                }
            })
            this.uploadVo.attachFileName = name
            this.uploadVo.attach = fileList
        },
        // 上传文件
        upload() {
            console.log('上传')
            this.dialogFormVisibleFolder = true
            this.isUpload = true
            this.addOrupdateContactsFolder = true
            this.uploadVo.folderId = Number(this.treeNode.id) === 0 ? '' : this.treeNode.id
            this.uploadVo.fullName = this.treeNode.folderName
            const cascadeIds = this.findCascadeIds(this.treeData1, this.uploadVo.fullName)
            // this.uploadVo.fullName1 = cascadeIds
            console.log(cascadeIds, 'cascadeIds')
            this.$nextTick(() => {
                console.log(this.$refs.cascader, 'this.$refs.cascader')
                this.$refs.cascader.inputValue = this.uploadVo.fullName
                this.$refs.cascader.checkedNodes = cascadeIds
                this.$refs.cascader.checkedValue = cascadeIds
            })

            this.uploadVo.deptId = this.treeNode.deptId
            this.uploadVo.deptName = this.treeNode.deptName
        },
        findCascadeIds(tree, fullName, parentIds = []) {
            for (const item of tree) {
                const currentIds = [...parentIds, item.id]
                if (item.folderName === fullName) {
                    return currentIds
                }
                if (item.children) {
                    const cascadeIds = this.findCascadeIds(item.children, fullName, currentIds)
                    if (cascadeIds) {
                        return cascadeIds
                    }
                }
            }
            return null
        },
        // 上传文件保存
        async groupingConfirmFolder() {
            var _this = this
            this.formValidate(async () => {
                this.updateLoading = true
                // _this.uploadVo.attach.forEach(res => {
                //     this.uploadFile(res)
                // })
                for (let index = 0; index < _this.uploadVo.attach.length; index++) {
                    const element = _this.uploadVo.attach[index]
                    this.uploadVo.progress = 0
                    this.uploadVo.uploadingFile = element.name

                    await this.uploadFile(element, index)
                }
                this.updateLoading = false
                this.dialogFormVisibleFolder = false
                // 刷新列表
                this.setListDataUrl()
            })
        },
        // 上传文件接口
        async uploadFile(item, index) {
            const files = item.raw
            const fd = new FormData()
            fd.append('file', files)
            fd.append('module', 'disk')
            // fd.append('attachsSize', val.size)
            fd.append('busiDataId', this.uploadVo.folderId)
            fd.append('attachsType', 'ATTACH')
            fd.append('fileDiffer', this.type)
            fd.append('attachsName', item.name)
            fd.append('folderId', this.uploadVo.folderId)
            fd.append('deptId', this.uploadVo.deptId)
            fd.append('deptName', this.uploadVo.deptName)

            const config = {
                onUploadProgress: (progressEvent) => {
                    const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                    this.uploadVo.progress = complete
                    this.$forceUpdate()
                },
                timeout: 30 * 60 * 1000
            }

            const url = '/disk/file/upload'
            await this.$http({
                method: 'POST',
                url: url,
                ...config,
                data: fd
            }).then((res) => {
                if (res.code === 'success') {
                    if (index === this.uploadVo.attach.length - 1) {
                        this.$message.success(res.message)
                    }
                } else {
                    this.$message.error(res.message)
                    return
                }
            })
        },
        // 新建文件夹
        addFolder() {
            this.addOrupdateContacts = true
            this.isUpload = false
            this.$http({
                url: this.fileMoudlueInfo.addNewUrl,
                method: 'POST'
            }).then((res) => {
                if (res.code === 'success') {
                    this.folderVo = res.body.vo
                    this.folderVo.parentId = this.treeNode.id !== '0' ? this.treeNode.id : null
                    this.folderVo.fullName = this.treeNode.folderName
                    const cascadeIds = this.findCascadeIds(this.treeData1, this.folderVo.fullName)
                    console.log(cascadeIds, 'cascadeIds')
                    // this.folderVo.fullName1 = cascadeIds
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs.cascaderServer.inputValue = this.folderVo.fullName
                        this.$refs.cascaderServer.checkedNodes = cascadeIds
                        this.$refs.cascaderServer.checkedValue = cascadeIds
                        console.log(this.$refs.cascaderServer, 'this.$refs.cascaderServer')
                    })

                    if (this.type === 1) {
                        this.folderVo.deptId = this.treeNode.deptId
                        this.folderVo.deptName = this.treeNode.deptName
                        if (!this.treeNode.fullId) {
                            this.folderVo.status = 3
                        }
                    } else {
                        this.folderVo.deptId = ''
                        this.folderVo.deptName = ''
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 保存文件夹
        async groupingConfirm() {
            var res = null
            this.formValidate(async () => {
                this.folderVo.folderType = this.type // 文件类型 0个人 1部门 2公司
                if (!this.folderVo.folderName) {
                    this.$alert('请输入文件夹名称', '提示', {
                        type: 'warning'
                    })
                } else {
                    delete this.folderVo.fullName1
                    if (this.folderVo.parentId === '1') {
                        this.folderVo.parentId = null
                    }
                    this.addOrupdateContacts ? (res = await this.$app.insert(this.fileMoudlueInfo.insertUrl, this.folderVo)) : (res = await this.$app.update(this.fileMoudlueInfo.updateUrl, this.folderVo))
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.dialogFormVisible = false
                        this.folderVo = {}
                        // 刷新树
                        this.$bus.emit('getTreeList', this.treeNode)
                        // 刷新选择分类
                        this.queryData()
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        // 编辑文件
        async editObjectFile(row) {
            // 文件夹
            if (Number(row.resoureType) === 1) {
                this.$bus.emit('editMenu', '文件夹', row, '重命名')
            } else {
                // 文件
                this.fileVo = { ...row }
                // 重点在这
                this.fileVo.name = row.name.substring(0, row.name.lastIndexOf('.'))
                this.fileVo.oldType = row.name.substring(row.name.lastIndexOf('.'))
                if (!this.fileVo.permissionType) {
                    this.fileVo.permissionType = 1
                }
                if (!this.fileVo.passenger.filePermission) {
                    this.fileVo.passenger.filePermission = {}
                    this.fileVo.passenger.filePermission.permissionName = ''
                    this.fileVo.passenger.filePermission.permissionId = ''
                }
                this.filePermissionName = this.fileVo.passenger.filePermission.permissionName || ''
                this.dialogFormVisibleFile = true
            }
        },
        // 重命名确定
        async fileConfirm() {
            this.formValidate(async () => {
                var res = null
                // 组合文件名格式
                this.fileVo.name = this.fileVo.name + this.fileVo.oldType
                res = await this.$app.update(this.moduleInfo.updateUrl, this.fileVo)
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    this.dialogFormVisibleFile = false
                    this.setListDataUrl()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 批量分享文件
        allShare() {
            this.shareType = 'all'
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择要分享的文件!', '操作提示', { type: 'warning' })
                return
            }
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfoShare, null, 1)
            })
        },
        // 操作列分享记录
        shareRecord(row) {
            this.$bus.$emit('ShareRecord', row)
        },
        // 转发邮件
        writeMail() {
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择要转发的文件!', '操作提示', { type: 'warning' })
                return
            }
            try {
                this.rowsSelected.forEach((res) => {
                    if (Number(res.resoureType) === 1) {
                        this.$alert('文件夹不可转发,请重新选择!', '操作提示', { type: 'warning' })
                        throw new Error(true)
                    }
                })
            } catch (e) {
                return
            }
            // this.gotoPages('email.svg', '1')
            var list = []
            var rowsSelected = [...this.rowsSelected]
            console.log('rowsSelected==', rowsSelected)
            rowsSelected.forEach((res) => {
                list.push({
                    busiDataId: '',
                    fileName: res.name,
                    fileMd5: null,
                    filePath: res.path,
                    fileRealSize: 999,
                    fileSize: res.size,
                    fileSort: 1,
                    fileType: 'ATTACH',
                    id: res.downId,
                    onlineFile: null,
                    orgCode: this.loginUser.orgCode,
                    orgName: this.loginUser.orgName,
                    originalName: res.originalName,
                    updateBy: res.createName,
                    updateTime: res.createDate,
                    uploadBy: res.createName,
                    uploadTime: res.createDate
                })
            })
            window.open('/#/sendmail?row=' + JSON.stringify(list) + '&srcBusiDataId=文件中心')
        },
        // 收藏
        collection(val) {
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择要收藏的文件!', '操作提示', { type: 'warning' })
                return
            }
            var list = []
            this.rowsSelected.map((res) => {
                list.push({
                    fileId: res.id,
                    fileType: res.resoureType, // 2文件 //1文件夹
                    fileSource: 1 // 0分享文件 1非分享文件
                })
            })
            this.$confirm('确认要收藏选中的文件吗？', '确认操作', { type: 'warning' })
                .then(() => {
                    this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        data: list,
                        url: '/disk/collect/insert'
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            // 刷新列表
                            this.setListDataUrl()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        // 单个收藏
        cancel: function (row) {
            var list = []
            list.push({
                fileId: row.id,
                fileType: row.resoureType, // 0文件 //1文件夹
                fileSource: 1 // 0分享文件 1非分享文件
            })
            this.$confirm('确认要收藏选中的文件吗？', '确认操作', { type: 'warning' })
                .then(() => {
                    this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        data: list,
                        url: '/disk/collect/insert'
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            // 刷新列表
                            this.$bus.$emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        // 单个取消收藏
        qxCancel: function (row) {
            this.$confirm('确认取消该收藏文件吗？', '确认操作', { type: 'warning' })
                .then(() => {
                    const params = {
                        ids: row.id,
                        status: 0
                    }
                    this.$http({
                        method: 'POST',
                        contentType: 'application/x-www-form-urlencoded',
                        params: params,
                        url: '/disk/vwcollectfile/updateCollect'
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            // 刷新列表
                            this.$bus.$emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch((err) => {
                    if (err !== 'cancel') {
                        console.error(err)
                    }
                })
        },
        // 批量删除
        allDeleteIds() {
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择需要删除的文件!', '操作提示', { type: 'warning' })
                return
            }
            this.$confirm('您是否确认删除选中的文件？', '确认操作', { type: 'warning' })
                .then(() => {
                    var id = ''
                    this.rowsSelected.forEach((res) => {
                        if (id) {
                            id += ',' + res.id
                        } else {
                            id += res.id
                        }
                    })
                    const params = {
                        ids: id
                    }

                    this.$http({
                        url: this.moduleInfo.delUrl,
                        method: 'DELETE',
                        contentType: 'application/x-www-form-urlencoded',
                        params: params
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            })
                            // 刷新树
                            this.$bus.emit('getTreeList', this.treeNode)
                            // 刷新选择分类
                            this.queryData()
                            // 刷新列表
                            this.$bus.$emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch(() => {})
        },
        // 操作列删除
        deleteIds(row) {
            let text = '您是否确认删除该文件？'
            if (Number(row.resoureType) === 1) {
                text = '您是否确认删除该文件夹？'
            }
            this.$confirm(text, '确认操作', { type: 'warning' })
                .then(() => {
                    const params = {
                        ids: row.id
                    }
                    this.$http({
                        url: this.moduleInfo.delUrl,
                        method: 'DELETE',
                        contentType: 'application/x-www-form-urlencoded',
                        params: params
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            })
                            // 刷新树
                            this.$bus.emit('getTreeList', this.treeNode)
                            // 刷新选择分类
                            this.queryData()
                            // 刷新列表
                            this.$bus.$emit('refreshListData')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
                .catch(() => {})
        },
        // 路由跳转
        gotoPages(code) {
            const toPath = this.getMenuCode(code)
            if (toPath && toPath.path) {
                let path
                switch (toPath.meta.level) {
                    case 3:
                        path = toPath.meta.activeMenu || toPath.path
                        break
                    case 4:
                        path = toPath.meta.activeMenu + '/' + toPath.path
                        break
                    default:
                        path = toPath.path
                }
                var list = []
                var rowsSelected = [...this.rowsSelected]
                rowsSelected.forEach((res) => {
                    list.push({
                        busiDataId: '',
                        fileName: res.name,
                        fileMd5: null,
                        filePath: res.path,
                        fileRealSize: res.actualSize,
                        fileSize: res.size,
                        fileSort: 1,
                        fileType: 'ATTACH',
                        id: res.id,
                        onlineFile: null,
                        orgCode: this.loginUser.orgCode,
                        orgName: this.loginUser.orgName,
                        originalName: res.originalName,
                        updateBy: res.createName,
                        updateTime: res.createDate,
                        uploadBy: res.createName,
                        uploadTime: res.createDate
                    })
                })
                this.$router.push({ path: path, query: { rowsSelected: list } })
            }
        },
        // 递归查询菜单代码
        getMenuCode(code) {
            let toPath
            function findCode(ary) {
                ary.forEach((val) => {
                    if (val.children) {
                        findCode(val.children)
                    }
                    if (!val.children && val.meta && val.meta.code === code) {
                        toPath = val
                        return false
                    }
                })
            }
            findCode(this.routes)
            return toPath
        },
        onListDataLoaded($scope, pageInfo) {
            // 只获取一次树的下边框最小高度为列表的高度
            if (!this.getBorder) {
                this.$bus.$emit('setHeight', $('.rightpanel').height())
            }
            // if (this.type === 0) {
            //     if (pageInfo.list.length > 0) {
            //         return (pageInfo.list = pageInfo.list.filter(item => item.accountId === this.accountId))
            //     }
            // }
            this.getBorder = true
        },
        operateActualSize(h, row, column, cellValue, index) {
            if (row.actualSize != null && row.actualSize != '') {
                return h('span', this.conver(Number(row.actualSize)))
            } else {
                return h('span', '0KB')
            }
        },
        // 转换大小加单位
        conver(limit) {
            var size = ''
            if (limit < 0.1 * 1024) {
                // 如果小于0.1KB转化成B
                size = limit.toFixed(2) + 'B'
            } else if (limit < 0.1 * 1024 * 1024) {
                // 如果小于0.1MB转化成KB
                size = (limit / 1024).toFixed(2) + 'KB'
            } else if (limit < 0.1 * 1024 * 1024 * 1024) {
                // 如果小于0.1GB转化成MB
                size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
            } else {
                // 其他转化成GB
                size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
            }

            var sizestr = size + ''
            var len = sizestr.indexOf('.')
            var dec = sizestr.substr(len + 1, 2)
            if (dec === '00') {
                // 当小数点后为00时 去掉小数部分
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
            }
            return sizestr
        },
        selectedRowsChange(rows) {
            this.rowsSelected = rows
        },
        // 批量下载附件
        allDownload() {
            if (this.rowsSelected.length > 0) {
                let ids = ''
                this.rowsSelected.forEach((res) => {
                    if (ids !== '') {
                        ids += ','
                    }
                    ids += res.id
                })
                window.open(process.env.VUE_APP_BASE_API + '/' + `${this.moduleInfo.downloadUrl}?inline=false&attachIds=` + ids + '&saveAs=' + (this.rowsSelected.length > 1 ? (this.rowsSelected[0].name.indexOf('.') !== -1 ? this.rowsSelected[0].name.split('.')[0] : this.rowsSelected[0].name) : this.rowsSelected[0].name))
            } else {
                this.$alert('请选择要下载的文件!', '操作提示', { type: 'warning' })
            }
        },
        // 操作列下载附件
        download(row) {
            if (!row.id) return
            if (row.name.indexOf('.ofd') > -1) {
                let downUrl = process.env.VUE_APP_BASE_API + '/' + this.moduleInfo.downloadUrl + '?inline=false&attachIds=' + row.id + '&fileName=' + row.name + '&saveAs=' + row.name
                window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
            } else {
                window.open(process.env.VUE_APP_BASE_API + '/' + `${this.moduleInfo.downloadUrl}?inline=false&attachIds=` + row.id + '&saveAs=' + row.name)
            }
        },
        // 移动文件
        mobile() {
            if (this.rowsSelected.length < 1) {
                this.$alert('请选择需要移动的文件!', '操作提示', { type: 'warning' })
                return
            }
            this.$bus.emit('mobile', this.rowsSelected)
        },
        setting(row) {
            let list = []
            if (row) list = [row]
            else list = this.rowsSelected
            this.$bus.emit('openDialog', { rowsSelected: list, url: '', edit: true })
        },
        cellclick(row, column, innerText, cellIndex) {
            // 文件夹
            debugger
            if (Number(row.resoureType) === 1) {
                this.setListDataUrl(row.id, row)
            } else {
                // 文件
                if (!row.id) return
                if (row.name.indexOf('.ofd') > -1) {
                    let downUrl = process.env.VUE_APP_BASE_API + '/' + this.moduleInfo.downloadUrl + '?inline=true&attachIds=' + row.id + '&fileName=' + row.name + '&saveAs=' + row.name
                    window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
                } else {
                    let onlineFile = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx']
                    let arr = row.name.split('.')
                    let nameType = '.' + arr[arr.length - 1]
                    if (onlineFile.includes(nameType)) {
                        window.open(process.env.VUE_APP_BASE_API + '/' + `${this.moduleInfo.downloadUrl}?topdf=true&inline=true&attachIds=` + row.id + '&saveAs=' + row.name)
                    } else {
                        window.open(process.env.VUE_APP_BASE_API + '/' + `${this.moduleInfo.downloadUrl}?inline=true&attachIds=` + row.id + '&saveAs=' + row.name)
                    }
                }
            }
        },
        // 请求接口前先判断是个人,部门,公司
        async isBeforeOpenSetListDataUrl() {
            const { staffList, orgCode, personId } = { ...this.loginUser }
            return new Promise((resolve) => {
                if (this.type === 0) {
                    // 个人
                    this.accountId = ''
                    this.$http({
                        method: 'GET',
                        url: '/disk/account/getByPersonId',
                        params: { personId: personId }
                    }).then((resp) => {
                        if (resp.code === 'success') {
                            this.accountId = resp.body.accountId
                        } else {
                            this.accountId = ''
                        }
                        resolve(`;accountId:${this.accountId || ''}`)
                    })
                } else if (this.type === 1) {
                    // 部门
                    let str = ''
                    staffList.forEach((res) => {
                        if (str) {
                            str += ',' + res.orgFullId.split('-')[1]
                        } else {
                            str += res.orgFullId.split('-')[1]
                        }
                    })
                    resolve(`;deptId:${str}`)
                } else if (this.type === 2) {
                    // 公司
                    resolve(`;orgCode:${orgCode}`)
                }
            })
        },
        // 后退
        back(row) {
            this.setListDataUrl(row.id, row.row, true)
        },
        // 请求接口
        async setListDataUrl(id, row, type) {
            this.isBeforeOpenSetListDataUrl().then((res) => {
                console.log(1530, res)
                const { orgCode } = { ...this.loginUser }
                let listDataUrl = '/disk/vwfilefolder/listdata'
                let urlsearch = ''
                if (id !== '0' && id) {
                    urlsearch = 'status!:2;orgCode:' + orgCode + ';folderId:' + id + ';fileDiffer:' + this.type
                } else {
                    if (this.searchType === '0') {
                        if (Number(this.treeNode.id) === 0) {
                            urlsearch = 'status!:2;orgCode:' + orgCode + ';fileDiffer:' + this.type + ';folderId:null' // 全部
                        } else if (Number(this.treeNode.id) === 1) {
                            urlsearch = `status:1;orgCode:${orgCode};fileDiffer:${this.type};createDate<:${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')};createDate>:${moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss')};resoureType:2` // 最近
                        } else {
                            urlsearch = 'status!:2;orgCode:' + orgCode + ';folderId:' + this.treeNode.id + ';fileDiffer:' + this.type
                        }
                    } else if (this.searchType === '1') {
                        urlsearch = 'status!:2;orgCode:' + orgCode + ';type:' + this.flieType + ';fileDiffer:' + this.type
                    }
                }
                urlsearch += res
                this.tableShow = false
                // 列表文件夹路径
                if (id) {
                    if (!type) {
                        this.levelList.push({
                            name: row.name,
                            row: row,
                            id: id
                        })
                    } else {
                        this.levelList.splice(this.levelList.length - 1, 1)
                    }
                } else {
                    this.levelList = [
                        {
                            name: this.treeNode.folderName,
                            id: this.treeNode.id
                        }
                    ]
                }
                // 触发树节点
                this.$bus.$emit('listOnTreeNodeClick', row)
                this.$nextTick(() => {
                    this.tableShow = true
                })
                this.$set(this.moduleInfo, 'listDataUrl', listDataUrl)
                this.$set(this.moduleInfo, 'urlsearch', urlsearch)
            })
        },
        onListDataBeforeLoad($scope, qparams) {
            console.log('typetype==', this.type)
            console.log('$scope==', $scope)
            console.log('accountId==', this.accountId)
            if (this.moduleInfo.urlsearch) {
                qparams.urlsearch = this.moduleInfo.urlsearch
                this.urlsearch = this.moduleInfo.urlsearch
            }
            if (!qparams.orderBy) {
                qparams.orderBy = 'resoureType asc,createDate desc'
            }
            if (this.showPicture) {
                this.$refs.cover.getPhotoSetById(this.prefixFullName, this.urlsearch)
            }
        },
        onBasicFormBeforeOpen($scope, vo, defer) {
            if (vo.isnew) {
                var text = ''
                var id = ''
                if (this.shareType === 'all') {
                    this.rowsSelected.map((res) => {
                        if (text) text += '、' + res.name
                        if (id) id += ',' + res.id
                        if (!text) text += res.name
                        if (!id) id += res.id
                    })
                } else {
                    text = this.shareObj.name
                    id = this.shareObj.id
                }
                vo.passenger.list = this.rowsSelected
                vo.resourceName = text
                vo.resourceId = id
                vo.shareScope = 1
                vo.sharePeriod = 0
                vo.resourceType = 2
            }
            defer.resolve(true)
        },
        onBasicFormOpened($scope, vo) {},
        onBasicFormBeforeSubmit($scope, vo, defer) {
            defer.resolve(true)
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
.el-col-14 {
    z-index: -1;
}
/deep/.el-upload--text {
    width: 100%;
}
.svg_stile {
    width: 13px;
    height: 13px;
    position: relative;
    top: 2px;
    margin: 0 5px 0 0;
}
.buttonTitle {
    display: flex;
    height: 32px;
}
//     .dataTable{
//   /deep/ .el-button--default{
//         border: none!important;
//     }
//     }
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: var(--portalFontSize14);
    line-height: 40px;

    .no-redirect {
        color: #909399;
        cursor: text;
    }

    /* .el-breadcrumb__item:last-child .no-redirect{
      color:#409eff;
    } */
    /deep/.el-breadcrumb__item:last-child .el-breadcrumb__separator {
        display: none;
    }
}
//按钮样式
/deep/.el-table-toolbar .el-row {
    line-height: 30px;
}

/deep/ .el-progress {
    margin: 20px auto;
}
</style>
